import { formatDate } from '../../../../utils/date'
import { type RequestDomain } from '../../../../types/domain/request-domain'

export const mapRequestDomainDataToTableRow = ({
  id,
  createdAt,
  enterAt,
  analyst,
  asset,
  client,
  projectName,
  requester,
  responsible,
  hasBecomeProject,
  description,
}: RequestDomain) => ({
  id,
  responsible: responsible?.user?.name,
  client: client?.name,
  requester: requester?.name,
  project: projectName,
  date: formatDate(new Date(enterAt)),
  asset: asset?.fullName,
  analyst: analyst?.fullName,
  description,
  hasBecomeProject,
  action: null
})
